import { render, staticRenderFns } from "./ministerDashboard.vue?vue&type=template&id=7712d93c&scoped=true&"
import script from "./ministerDashboard.vue?vue&type=script&lang=js&"
export * from "./ministerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ministerDashboard.vue?vue&type=style&index=0&id=7712d93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7712d93c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressCircular,VProgressLinear})
